import "../styles/globals.css";
import "../styles/media-queries.scss";
import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../src/theme";
import ErrorBoundary from "../shared/core/components/error/ErrorBoundary";
import {  type ReactElement, type ReactNode } from "react";
import type { NextPage } from "next";
import type { AppProps } from "next/app";
import { IntlProvider } from "next-intl";
import { logger } from "../shared/core";
import TopLoader from "../shared/core/components/top-loader/top-loader";


export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  const getLayout = Component.getLayout ?? ((page) => page);
 
  const onErrorReceive = (v: any) => {
    logger.log("error ", v);
  };

  return (
    <IntlProvider
      // To achieve consistent date, time and number formatting
      // across the app, you can define a set of global formats.
      formats={{
        dateTime: {
          short: {
            day: "numeric",
            month: "short",
            year: "numeric",
          },
        },
      }}
      onError={onErrorReceive}
      // Messages can be received from individual pages or configured
      // globally in this module (`App.getInitialProps`). Note that in
      // the latter case the messages are available as a top-level prop
      // and not nested within `pageProps`.
      messages={pageProps.messages}
      // Providing an explicit value for `now` ensures consistent formatting of
      // relative values regardless of the server or client environment.
      now={new Date(pageProps.now)}
      // Also an explicit time zone is helpful to ensure dates render the
      // same way on the client as on the server, which might be located
      // in a different time zone.
      timeZone="Asia/Kolkata"
      locale="Asia/Kolkata"
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
            <TopLoader /> 
          {getLayout(<Component {...pageProps} />)}
          </ErrorBoundary>
      </ThemeProvider>
    </IntlProvider>
  );
}

export default MyApp;
 